import { createElement } from "./dom_helpers"

export function svgIcon(name) {
  const span = createElement("span")
  fetchSvg(name).then((svg) => svg && span.append(svg))
  return span
}

const loaders = {}
async function fetchSvg(name) {
  const element = await (loaders[name] ??= loadSvg(name))
  if (element) return element.cloneNode(true)
}

async function loadSvg(name) {
  const resp = await fetch(`/images/${name}.svg`)
  if (resp.ok) return parseSvg(await resp.text())
}

function parseSvg(string, type = "image/svg+xml") {
  return new DOMParser().parseFromString(string, type).documentElement
}
